import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Dispatch, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { buttonStyle } from './datagrid/ViewLocation';

interface DialogModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  contentText: string;
  buttonText?: string;
  doAction: () => void;
  closeAction?: () => void;
}

export function DialogModal(props: DialogModalProps) {
  const {
    open,
    setOpen,
    title,
    contentText,
    doAction,
    buttonText = 'Delete',
    closeAction = undefined,
  } = props;
  const classes = buttonStyle();
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={closeAction ?? handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAction ?? handleClose}>
          {t('actions.cancel')}
        </Button>
        <Button
          classes={{
            root: classes.button,
          }}
          onClick={() => {
            doAction();
            closeAction ? closeAction() : handleClose();
          }}
          autoFocus
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
